import { render } from "./StudentUserOrder.vue?vue&type=template&id=499168c2&scoped=true"
import script from "./StudentUserOrder.vue?vue&type=script&lang=js"
export * from "./StudentUserOrder.vue?vue&type=script&lang=js"

import "./StudentUserOrder.vue?vue&type=style&index=0&id=499168c2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499168c2"]])

export default __exports__